<ng-select
  [items]="options"
  [ngModel]="selectedValues"
  [required]="required"
  [multiple]="true"
  [closeOnSelect]="true"
  [addTag]="true"
  [class.invalid]="control?.invalid && control?.touched"
  [placeholder]="placeholder | translate"
  (ngModelChange)="onSelectionChange($event)">
  <ng-template ng-option-tmp let-item="item" let-selected="selected">
    <div class="layout-row layout-align-start-center">
      <app-bringoz-checkbox [isChecked]="selectedKeys[item]"></app-bringoz-checkbox>
      <span class="br-body-2 font-weight-400 secondary-100 margin-left-5">{{item}}</span>
    </div>
  </ng-template>
</ng-select>

<p *ngIf="control?.invalid && control?.touched" class="invalid-error-message">
  This field is required!
</p>
